// KB국민은행 입출금내역 자동통지서비스 신청 안내 (2026-07-04 오너 라이브 실측).
// Type B: 인증코드 없음(신청자 ARS 본인인증=셀러 본인폰. 게이트웨이는 통지 SMS만 수신).
// ★KB는 앱 신청 불가 — PC 인터넷뱅킹(obank.kbstar.com) 전용.
import type { GuideStep } from './guideStepPrimitives';

// 순차 동작(한 스텝에 하나씩). 구체 값은 아래 KB_NOTIFY_OPTIONS 체크리스트로 분리.
export const KB_REGISTER_STEPS: GuideStep[] = [
  {
    title: 'KB 인터넷뱅킹(PC)에 접속',
    detail: 'KB는 문자통지 신청이 앱에선 안 되고 인터넷뱅킹에서만 돼요.',
    href: 'https://obank.kbstar.com',
    linkLabel: 'KB 인터넷뱅킹 열기',
  },
  { title: '뱅킹관리 → 인터넷뱅킹관리 → 입출금내역 자동통지서비스 → 신청' },
  { title: '통지대상계좌 선택' },
  { title: '통지매체번호에 위 셀러헬퍼 번호 입력' },
  { title: '아래 "통지 옵션"대로 맞춘 뒤 [등록]' },
  {
    title: '내 폰으로 오는 ARS 전화로 본인인증하면 완료',
    detail: 'ARS는 신청자(사장님) 본인 확인용이라 내 폰으로 와요.',
  },
];

// 신청 화면에서 정확히 이 값으로 골라야 함(라벨 : 값).
export const KB_NOTIFY_OPTIONS: GuideStep[] = [
  {
    title: '통지내용 : 거래내역통지',
    titleTone: 'danger',
    detail: '송금인명·계좌번호가 나오는 항목. "거래발생통지"는 매칭이 안 돼요.',
    detailTone: 'danger',
  },
  { title: '통지대상구분 : 입금 통지' },
  { title: '통지대상금액 : 비워두기 (제한 없음)' },
  { title: '통지대상범위 : 모든거래 (센터컷 포함)' },
  { title: '통지매체 : 휴대폰 문자(SMS)' },
  { title: '통지시간 : 실시간 통지' },
];
